import React, { useMemo, useState, useRef, useEffect } from 'react';
import { usePrevious, useAnimation } from "components/common/hooks";
import PropTypes from 'prop-types';
const AnimateScrollList = (props) => {
    const { ulStyle, locationsName, locationCol, duration } = props
    const durationTime = ((duration * 1000) - 1500) / 2; // miliseconds

    const scrollListRef = useRef(null);

    const [scrollValue, setScrollValue] = useState(0);
    const [scrollState, setScrollState] = useState("down");
    const [scrollHeight, setScrollHeight] = useState(0);
    const [offsetHeight, setOffsetHeight] = useState(0);


    const prevScrollState = usePrevious(scrollState);

    const isUp = useMemo(() => scrollState === "up", [scrollState]);

    const { value: scrollAnimation, animationState } = useAnimation(
        "linear",
        durationTime,
        isUp ? 501 : 500 // definitely a hack
    );

    const scrollMax = useMemo(() => scrollHeight - offsetHeight, [
        scrollHeight,
        offsetHeight
    ]);

    useEffect(() => {
        if (!scrollMax) return;

        if (scrollValue === 0 && scrollState !== "down") {
            setScrollState("down");
        } else if (scrollValue >= scrollMax && scrollState !== "up") {
            setScrollState("up");
        }
    }, [scrollValue, scrollMax, animationState, scrollState]);

    useEffect(() => {
        if (animationState === "idle") return;

        const value = scrollMax * scrollAnimation;

        const isSameScroll = prevScrollState === scrollState;

        if (animationState === "finished" && isSameScroll) {
            const finishedValue = isUp ? 0 : scrollMax;
            if (value !== finishedValue) {
                setScrollValue(finishedValue);
                return;
            }
        }
        if (animationState !== "started") return;

        setScrollValue(isUp ? scrollMax - value : value);
    }, [
        scrollAnimation,
        scrollMax,
        isUp,
        animationState,
        prevScrollState,
        scrollState
    ]);

    useEffect(() => {
        const { current } = scrollListRef;
        if (!current) return;

        current.scrollTop = scrollValue;
    }, [scrollValue]);

    useEffect(() => {
        const { current } = scrollListRef;
        if (current !== null) {
            setScrollHeight(current.scrollHeight);
            setOffsetHeight(current.offsetHeight);
        }
    }, [locationCol, locationsName])

    return (
        <div className="locationsList-container">
            <ul
                className={"row ul-list list-scroll"}
                ref={scrollListRef}
                style={ulStyle}>
                {locationsName.map((name, i) =>
                    <li key={i} className={`col-xs-${locationCol}`}> {name}</li>
                )}

            </ul>
        </div>
    );
}

AnimateScrollList.propTypes = {
    ulStyle: PropTypes.object.isRequired,
    locationsName: PropTypes.array.isRequired,
    locationCol: PropTypes.number.isRequired,
    duration: PropTypes.number.isRequired
}
export default AnimateScrollList;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/LivefeedPreview/LeftPaneView/entity/LocationsList/AnimateScrollList.jsx